export function startDateDelta(startDate, nextStartDate, fullDate, nextEndDate) {
  let inStartDateDelta

  if (nextStartDate !== startDate) {
    const startDateDelta = [startDate, nextStartDate].sort()
    inStartDateDelta = fullDate >= startDateDelta[0] && fullDate <= (nextEndDate || startDateDelta[1])
  }

  return inStartDateDelta
}

export function endDateDelta(endDate, nextEndDate, fullDate, nextStartDate) {
  let inEndDateDelta

  if (nextEndDate !== endDate) {
    const endDateDelta = [endDate, nextEndDate || nextStartDate].sort()
    inEndDateDelta = fullDate >= endDateDelta[0] && fullDate <= endDateDelta[1]
  }

  return inEndDateDelta
}

export function hoveredDateDelta(hoveredDate, nextHoveredDate, fullDate) {
  let inHoveredDateDelta = false

  if (nextHoveredDate !== hoveredDate) {
    const hoveredDateDelta = [hoveredDate, nextHoveredDate].sort()
    inHoveredDateDelta = fullDate >= hoveredDateDelta[0] && fullDate <= hoveredDateDelta[1]
  }

  return inHoveredDateDelta
}

export function fullDateChanged(fullDate, nextFullDate) {
  return fullDate !== nextFullDate
}

export function startsWithSunday(startsWithSunday, nextStartsWithSunday) {
  return nextStartsWithSunday !== startsWithSunday
}

export function selectableDateDelta(maxSelectableDate, nextMaxSelectableDate, fullDate) {
  let inSelectableDateDelta = false

  if (nextMaxSelectableDate !== maxSelectableDate) {
    const selectableDateDelta = [maxSelectableDate, nextMaxSelectableDate].sort()
    inSelectableDateDelta = fullDate >= selectableDateDelta[0] && fullDate <= selectableDateDelta[1]
  }

  return inSelectableDateDelta
}

export function executeWhenIsNewHoverDate(hoveredDate, nextHoveredDate, fullDate, callback) {
  if (nextHoveredDate !== hoveredDate && parseInt(fullDate) === Number(nextHoveredDate)) {
    callback()
  }
}
